import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

const BIRTHDAY_KEY = 'sstc_bday_toast_shown_'; // + YYYY-MM-DD + user_id
// Note: `sessionStorage` (not localStorage) is used so the flag naturally clears
// on browser close. This is only a UX de-dup flag — no sensitive data is stored.

const isTodayBirthday = (dob) => {
  if (!dob) return false;
  try {
    const [y, m, d] = dob.split('T')[0].split('-').map(Number);
    if (!m || !d) return false;
    const now = new Date();
    return now.getMonth() + 1 === m && now.getDate() === d;
  } catch (e) {
    return false;
  }
};

/**
 * Shows a warm one-time toast when it's the user's birthday today (once per day per user).
 * @param {object} user - current logged in user (must include id and date_of_birth)
 */
export function useBirthdayGreeting(user) {
  const fired = useRef(false);
  useEffect(() => {
    if (fired.current) return;
    if (!user || !user.id) return;
    if (!isTodayBirthday(user.date_of_birth)) return;
    const today = new Date().toISOString().slice(0, 10);
    const key = `${BIRTHDAY_KEY}${today}_${user.id}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
    fired.current = true;
    const wishes = [
      `Happy Birthday, ${user.name}! Wishing you a bright, joyful year ahead.`,
      `Happy Birthday, ${user.name}! May today sparkle just like you.`,
      `It's your day, ${user.name}! May you be surrounded by love and cake.`,
      `Happy Birthday, ${user.name}! Blow out those candles and dream big.`,
    ];
    const pick = wishes[Math.floor(Math.random() * wishes.length)];
    toast.success(pick, {
      duration: 10000,
      description: 'The whole SSTC family is cheering for you today.',
    });
  }, [user]);
}

export default useBirthdayGreeting;
